import React from "react";
import { Badge, Head, Heading, Section, Sub } from "./NumberedSection.styles";
import type { NumberedSectionProps } from "./NumberedSection.types";

/** A numbered part of a task, labelled by its heading. */
export const NumberedSection: React.FC<NumberedSectionProps> = ({ id, number, title, sub, children, className }) => (
  <Section aria-labelledby={id} className={className}>
    <Head>
      <Heading>
        <Badge aria-hidden="true">{number}</Badge>
        <span id={id}>{title}</span>
      </Heading>
      {sub ? <Sub>{sub}</Sub> : null}
    </Head>
    {children}
  </Section>
);

export default NumberedSection;
